<div class="picker">
  <!-- Picker header: tri-state Select-all cascading to every service + sub-type.
       Hidden when showSelectAll is false (e.g. Section 1, which has no bulk
       endpoint to back an all-at-once toggle). -->
  <div class="picker__header" *ngIf="showSelectAll">
    <label class="select-all">
      <input
        type="checkbox"
        class="select-all__box"
        [checked]="allSelected"
        [indeterminate]="selectAllIndeterminate"
        data-testid="picker-select-all"
        (change)="toggleSelectAll()"
      />
      <span class="select-all__label">Select all</span>
    </label>
  </div>

  <!-- Prominent legend: with the old hover-✕ removal cue gone, this spells out
       how selection works at both levels — the service checkbox and the
       specialty chip click — and shows a sample of each chip state so the
       dark-blue "selected" chip vs the outlined "not offered" chip are
       unmistakable. The sample chips use their own .legend-chip classes (not
       .chip) so they don't count against the real specialty chips. -->
  <div class="picker__legend" role="note">
    <div class="picker__legend-main">
      <span class="material-icons picker__legend-icon" aria-hidden="true"
        >info</span
      >
      <p class="picker__legend-text">
        Check a service's box to select it, uncheck to deselect it.<br />
        Click a specialty to select or deselect it.
      </p>
    </div>
    <div class="picker__legend-key">
        <span class="legend-item">
          <span class="legend-chip legend-chip--on" aria-hidden="true">
            <span class="legend-chip__icon material-icons">check</span>
            <span class="legend-chip__label">Example</span>
          </span>
          <span class="legend-item__text">Selected</span>
        </span>
        <span class="legend-item">
          <span class="legend-chip" aria-hidden="true">
            <span class="legend-chip__label">Example</span>
          </span>
          <span class="legend-item__text">Not Selected</span>
        </span>
      </div>
  </div>

  <!-- Responsive auto-fill grid of service cards. -->
  <div class="picker__grid">
    <div
      *ngFor="let service of services"
      class="svc-card"
      [class.svc-card--off]="!service.enabledForZone"
    >
      <!-- Header: include checkbox + name + informational N/M count. -->
      <label class="svc-card__header">
        <input
          type="checkbox"
          class="svc-card__box"
          [(ngModel)]="service.enabledForZone"
          [attr.data-testid]="'picker-service-' + serviceTestKey(service) + '-toggle'"
          (ngModelChange)="onServiceToggle(service)"
        />
        <span class="svc-card__name">{{ service.displayName }}</span>
        <span
          *ngIf="service.enabledForZone && subTypeCount(service) > 0"
          class="svc-card__count"
          [attr.aria-label]="
            selectedSubTypeCount(service) +
            ' of ' +
            subTypeCount(service) +
            ' specialties selected'
          "
        >
          {{ selectedSubTypeCount(service) }}/{{ subTypeCount(service) }}
          Specialties Selected
        </span>
      </label>

      <!-- Specialties render only while the service is included. -->
      <ng-container *ngIf="service.enabledForZone">
        <div
          *ngIf="subTypeCount(service) > 0; else noSpecialties"
          class="svc-card__chips"
        >
          <button
            type="button"
            *ngFor="let subType of service.serviceSubTypes"
            class="chip"
            [class.chip--on]="subType.enabledForZone"
            [attr.data-testid]="
              'picker-service-' +
              serviceTestKey(service) +
              '-specialty-' +
              subTypeTestKey(subType)
            "
            (click)="toggleSubType(service, subType)"
          >
            <!-- Selected chip: a check icon marks it as offered. Clicking the
                 chip again deselects it (see the legend). -->
            <span
              *ngIf="subType.enabledForZone"
              class="chip__icon material-icons"
              aria-hidden="true"
              >check</span
            >
            <span class="chip__label">{{ subType.displayName }}</span>
          </button>
        </div>
        <ng-template #noSpecialties>
          <div class="svc-card__no-specialties">No specialties</div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
